import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';

import { PureComponent, Page } from 'core/components';
import { Availability } from 'content/components';
import { Row, Col, Icon, Button, Block, ListItem, List, AccordionContent, Navbar, NavRight, Link, Popup, Sheet } from 'core/components/Framework7';

import classes from './styles.module.css';

class Filter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sort: props.sort,
      filter: props.filter,
      availability: this.initialValue.checkAvailability,
      sheetFilterOpened: false,
      sheetSortOpened: false,
    }
  }

  get initialValue() {
    const { env } = this.props;

    // console.log("Filter:", env)

    return {
      checkAvailability: env ? env.checkAvailability : null,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log(this.props, prevProps)
    this.setState({
      filter: this.props.filter,
      sort: this.props.sort
    })
  }

  changeAvailability(value) {
    this.setState({
      availability: value
    }, () => {
      this.props.onAvailabilityChange(this.state.availability)
    })
  }

  changeSort(value) {
    this.setState({
      sort: value,
      sheetSortOpened: false,
    }, () => {
      // this.props.sortFilter && this.props.sortFilter(this.state.sort, "order_by")
      this.props.onSortChange(this.state.sort, "order_by")
    })
  }

  changeFilter(value) {
    this.setState({
      filter: value,
      sheetFilterOpened: false,
    }, () => {
      // this.props.sortFilter && this.props.sortFilter(this.state.filter, "brand")
      this.props.onFilterChange(this.state.filter, "brand")
    })
  }

  renderBrands() {
    const { filter } = this.state;
    const { brands } = this.props;

    return (
      <List>
        {brands && brands.map((brand, index) => {
          return (
            <ListItem
              key={index}
              radio
              title={brand.name}
              value={brand.id}
              checked={filter === brand.id}
              onClick={() => { this.changeFilter(brand.id) }}
            />
          )
        })}
      </List>
    )
  }

  renderSheetFilter() {
    const { filter } = this.state;

    return (
      <Popup
        id={'popup-filter'}
        closeByOutsideClick
        // swipeToClose
        opened={this.state.sheetFilterOpened}
        onPopupClosed={() => { this.setState({ sheetFilterOpened: false }) }}
      >
        <Page
          pageName="filter-page"
          title={'فیلتر'}
          showBack={false}
          showClose={true}
          closePopup={true}
          closePopupClassName={'#popup-filter'}
          background={classes.pageBackground}
          onCloseNavClicked={() => { this.setState({ sheetFilterOpened: false }) }}
        >
          <div className={classes.container}>
            {filter &&
              <Button large raised
                text={'حذف فیلتر'}
                icon="mdi-trash-can-outline"
                className={`${classes.fullWidthButton} button-top-full-width`}
                onClick={() => { this.changeFilter(null) }}
              />
            }
            <div className={`${classes.pagePadding}`}>
              <List accordionList inset>
                <ListItem accordionItem
                  title={`برند ${filter ? '(1)' : ''}`}
                >
                  <AccordionContent>
                    {this.renderBrands()}
                    {/* TODO insert other filters */}
                  </AccordionContent>
                </ListItem>
              </List>
            </div>
          </div>
        </Page>
      </Popup>
    )
  }

  renderSheetSort() {
    const { sort } = this.state
    return (
      <Popup
        id={'popup-sort'}
        closeByOutsideClick
        // swipeToClose
        opened={this.state.sheetSortOpened}
        onPopupClosed={() => { this.setState({ sheetSortOpened: false }) }}
      >
        <Page
          pageName="filter-page"
          title={'مرتب‌سازی'}
          showBack={false}
          showClose={true}
          closePopup={true}
          closePopupClassName={'#popup-sort'}
          background={classes.pageBackground}
          onCloseNavClicked={() => { this.setState({ sheetSortOpened: false }) }}
        >
          <div className={classes.container}>
            {sort &&
              <Button large raised
                text={'حذف مرتب‌سازی'}
                icon="mdi-trash-can-outline"
                className={`${classes.fullWidthButton} button-top-full-width`}
                onClick={() => { this.changeSort(null) }}
              />
            }
            <div className={`${classes.pagePadding}`}>
              <List inset>
                <ListItem
                  radio
                  title={'جدیدترین‌'}
                  checked={sort === "newest"}
                  onClick={() => { this.changeSort('newest') }}
                >
                  <Icon slot="media" icon="mdi-new-box" />
                </ListItem>
                <ListItem
                  radio
                  title={'پر‌تخفیف‌ترین'}
                  checked={sort === "more_discount"}
                  onClick={() => { this.changeSort('more_discount') }}
                >
                  <Icon slot="media" icon="mdi-sale" />
                </ListItem>
                <ListItem
                  radio
                  title={'محبوب‌ترین‌'}
                  checked={sort === "most_popular"}
                  onClick={() => { this.changeSort('most_popular') }}
                >
                  <Icon slot="media" icon="mdi-thumb-up" />
                </ListItem>
                <ListItem
                  radio
                  title={'پرفروش‌ترین'}
                  checked={sort === "best_sellers"}
                  onClick={() => { this.changeSort('best_sellers') }}
                >
                  <Icon slot="media" icon="mdi-coins" />
                </ListItem>
                <ListItem
                  radio
                  title={'ارزان‌ترین'}
                  checked={sort === "cheapest"}
                  onClick={() => { this.changeSort('cheapest') }}
                >
                  <Icon slot="media" icon="mdi-sort-ascending" />
                </ListItem>
                <ListItem
                  radio
                  title={'گران‌ترین'}
                  checked={sort === "most_expensive"}
                  onClick={() => { this.changeSort('most_expensive') }}
                >
                  <Icon slot="media" icon="mdi-sort-descending" />
                </ListItem>
              </List>
            </div>
          </div>
        </Page >
      </Popup >
    )
  }

  render() {
    const { availability } = this.state

    // console.log("filter sheet", this.state.sheetFilterOpened)

    return (
      <React.Fragment>
        <Row noGap className={`${classes.filter} button-top-full-width`}>
          <Col width="25">
            <Button
              text={'فیلتر'}
              icon="mdi-filter"
              className={classes.iconButton}
              onClick={() => { this.setState({ sheetFilterOpened: true, sheetSortOpened: false }) }}
            />
          </Col>
          <Col width="25">
            <Button
              text={'مرتب‌سازی'}
              icon="mdi-sort-variant"
              className={classes.iconButton}
              onClick={() => { this.setState({ sheetSortOpened: true, sheetFilterOpened: false }) }}
            />
          </Col>
          <Col width="50">
            <Availability
              defaultChecked={availability}
              availability={this.changeAvailability}
            />
          </Col>
        </Row>

        {this.renderSheetFilter()}

        {this.renderSheetSort()}
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {

  }
)(autobind(Filter));
